<template>
<activemobileApp></activemobileApp>    
</template>


<script>
import activemobileApp from '@/components/login/activemobileApp';
export default {
   name:'ActiveMobile',
   components:{activemobileApp}
}
</script>